"use strict";

angular.module("core")
// Source: https://stackoverflow.com/questions/8068052/phonegap-detect-if-running-on-desktop-browser/40554200#40554200
// Source: https://dev.to/itsabdessalam/detect-current-device-type-with-javascript-490j
.constant("IS_MOBILE_APP", !!navigator.userAgent.match(/Cordova/i))
.constant("IS_MOBILE", !!navigator.userAgent.match(/Mobile/i))
.constant("IS_TABLET", !!navigator.userAgent.match(/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i))
.constant("MOBILE_APP_VERSION",
    (
        function() {
            var match = navigator.userAgent.match(/WGT\/(\d+\.\d+\.\d+)$/)
            if (match) {
                return match[1];
            }
            return null;
        }
    )()
);



//////////////////
// WEBPACK FOOTER
// ./core/mobile-app/mobile-app.constant.js
// module id = 387
// module chunks = 0